import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

const initialState = {};

const fetchAudits = (state, { meta, payload }) => {
  if (meta?.source === 'link-audit') {
    return payload?.page ?? {};
  }
  return state;
};

const clearIds = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_SUCCESS]: fetchAudits,
  [actionTypes.CLEAR_COLLECTION]: clearIds,
});
